<template>
  <div>
    <!--기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
    />

    <!--협의체 정보-->
    <div class="mt-5">
      <vs-row class="my-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i>{{ $t('협의체 정보') }}</h5>
        </vs-col>
      </vs-row>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">{{ $t('구분') }}</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputA_1 }}</p>
          <ml-input
            v-else-if="board.readonly"
            v-model="form.inputA_1"
            :readonly="board.readonly"
            class="w-full flex-1"
          />
          <vs-select
            v-else
            v-model="form.inputA_1"
            autocomplete
            :disabled="board.readonly"
            class="w-full flex-1"
          >
            <vs-select-item text="정기" value="정기" />
            <vs-select-item text="수시" value="수시" />
          </vs-select>
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">{{ $t('협의일') }}</div>
          <p v-if="isPrint" class="print-input flex-1">
            {{ form.inputA_2 }}
          </p>
          <div v-else class="flex-1 flex items-center">
            <date-selector
              class="w-full"
              v-model="form.inputA_2"
              :readonly="board.readonly"
            />
          </div>
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">{{ $t('회의장소') }}</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputA_3 }}</p>
          <ml-input
            v-else
            v-model="form.inputA_3"
            :readonly="board.readonly"
            class="w-full flex-1"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">{{ $t('도급인(명)') }}</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputA_4 }}</p>
          <comma-input
            v-else
            :readonly="board.readonly"
            v-model="form.inputA_4"
            class="w-full flex-1"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">{{ $t('하도급인(명)') }}</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputA_5 }}</p>
          <comma-input
            v-else
            :readonly="board.readonly"
            v-model="form.inputA_5"
            class="w-full flex-1"
          />
        </div>
      </div>
    </div>

    <table-custom
      :board="board"
      :is-print="isPrint"
      title="도급인(사용자)"
      :tableData="[
        { id: 'input1', title: '소속명', type: 'text', placeholder: '내용' },
        {
          id: 'input2',
          title: '직책',
          type: 'select',
          selectData: [
            '사용자대표',
            '안전관리자',
            '보건관리자',
            '관리감독자',
            '사용자위원',
            '기타',
          ],
          placeholder: '선택',
        },
        { id: 'input3', title: '이름', type: 'text', placeholder: '내용' },
        { id: 'input4', title: '서명', type: 'text', placeholder: '내용' },
        { id: 'input5', title: '비고', type: 'text', placeholder: '내용' },
      ]"
      v-model="form.user"
    />
    <table-custom
      :board="board"
      :is-print="isPrint"
      title="하도급인(근로자)"
      :tableData="[
        { id: 'input1', title: '소속명', type: 'text', placeholder: '내용' },
        {
          id: 'input2',
          title: '직책',
          type: 'select',
          selectData: [
            '근로자대표',
            '명예산업안전감독관',
            '근로자위원',
            '기타',
          ],
          placeholder: '선택',
        },
        { id: 'input3', title: '이름', type: 'text', placeholder: '내용' },
        { id: 'input4', title: '서명', type: 'text', placeholder: '내용' },
        { id: 'input5', title: '비고', type: 'text', placeholder: '내용' },
      ]"
      v-model="form.worker"
    />

    <!-- 협의내용 -->
    <div class="mt-5">
      <vs-row class="my-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i>{{ $t('협의내용') }}</h5>
        </vs-col>
      </vs-row>

      <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">{{ $t('대상기간') }}</div>
          <p v-if="isPrint" class="print-input flex-1">
            {{ form.inputB_1 }} ~ {{ form.inputB_2 }}
          </p>
          <div v-else class="flex-1 flex items-center">
            <date-selector
              class="w-full flex-1"
              v-model="form.inputB_1"
              :readonly="board.readonly"
            />
            <p class="px-2">~</p>
            <date-selector
              class="w-full flex-1"
              v-model="form.inputB_2"
              :readonly="board.readonly"
            />
          </div>
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">{{ $t('재해형태(필수)') }}</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputB_3 }}</p>
          <ml-input
            v-else-if="board.readonly"
            v-model="form.inputB_3"
            readonly
            class="w-full flex-1"
          />
          <disaster-class-selector
            v-else
            class="w-full flex-1"
            v-model="form.inputB_3"
            :readonly="board.readonly"
          />
        </div>
      </div>
      <div class="print-container col-span-12 flex items-start mt-4">
        <div class="label-text mr-4 mt-2">{{ $t('작업 시작 시간 (공종별)') }}</div>
        <span v-if="isPrint" class="print-textarea flex-1">
          {{ form.inputB_4 }}
        </span>
        <ml-textarea
          v-else
          class="flex-1 w-full"
          rows="5"
          v-model="form.inputB_4"
          :readonly="board.readonly"
        />
      </div>
      <div class="print-container col-span-12 flex items-start">
        <div class="label-text mr-4 mt-2">{{ $t('작업장 간의 연락방법') }}</div>
        <span v-if="isPrint" class="print-textarea flex-1">
          {{ form.inputB_5 }}
        </span>
        <ml-textarea
          v-else
          class="flex-1 w-full"
          rows="5"
          v-model="form.inputB_5"
          :readonly="board.readonly"
        />
      </div>
      <div class="print-container col-span-12 flex items-start">
        <div class="label-text mr-4 mt-2">{{ $t('도급인과 수급인 또는 수급인 상호간의 연락 방법 및 작업공정의 조정') }}</div>
        <span v-if="isPrint" class="print-textarea flex-1">
          {{ form.inputB_6 }}
        </span>
        <ml-textarea
          v-else
          class="flex-1 w-full"
          rows="5"
          v-model="form.inputB_6"
          :readonly="board.readonly"
        />
      </div>
      <div class="print-container col-span-12 flex items-start">
        <div class="label-text mr-4 mt-2">{{ $t('재해발생 위험이 있는 경우 대피방법') }}</div>
        <span v-if="isPrint" class="print-textarea flex-1">
          {{ form.inputB_7 }}
        </span>
        <ml-textarea
          v-else
          class="flex-1 w-full"
          rows="5"
          v-model="form.inputB_7"
          :readonly="board.readonly"
        />
      </div>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
        <div class="col-span-4 flex items-start mb-4">
          <div class="label-text mr-4">{{ $t('대피로 약도 첨부') }}</div>
          <p v-if="isPrint" class="print-input flex-1">
            {{ form.inputB_8.fileName }}
          </p>
          <file-uploader
            :readonly="board.readonly"
            v-else
            v-model="form.inputB_8"
            class="w-full flex-1"
          />
        </div>
      </div>
      <div class="print-container col-span-12 flex items-start">
        <div class="label-text mr-4 mt-2">{{ $t('기타 작업수행에 따른 안전·보건 조치사항 / 수급인의 건의사항 등') }}</div>
        <span v-if="isPrint" class="print-textarea flex-1">
          {{ form.inputB_9 }}
        </span>
        <ml-textarea
          v-else
          class="flex-1 w-full"
          rows="5"
          v-model="form.inputB_9"
          :readonly="board.readonly"
        />
      </div>
    </div>

    <!-- 사진대지 -->
    <photo-upload-grid-module
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList"
      :is-print="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
      placeholder="점검 현장 사진"
    />

    <!-- 파일첨부 -->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import DateSelector from "@/components/selector/DateSelector";
import FileUploadModule from "@/views/modules/FileUploadModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import TableCustom from "@/components/TableCustom.vue";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector";
import FileUploader from "@/components/FileUploader";

export default {
  components: {
    FieldSelectModule,
    DateSelector,
    PhotoUploadGridModule,
    FileUploadModule,
    TableCustom,
    DisasterClassSelector,
    FileUploader,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      important: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {},
  data() {
    return {
      form: {
        stdInfo: {},

        inputA_1: "",
        inputA_2: "",
        inputA_3: "",
        inputA_4: "",
        inputA_5: "",

        inputB_1: "",
        inputB_2: "",
        inputB_3: "",
        inputB_4: "",
        inputB_5: "",
        inputB_6: "",
        inputB_7: "",
        inputB_8: {},
        inputB_9: "",

        user: [],
        worker: [],

        photoList: [],
        fileList: [],
      },
    };
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
</style>
